(function ($) {

'use strict';

	/**
	 * History state object handler.
	 * Store/restore form values
	 */
	$.formHistoryStateHelper = {
		/**
		 * Set the current search parameters to a new history state 
		 * @param {jQuery} $container - a container object which contains the input elements to handle
		 * @param {string} objName - name to use for the form data history object
		 * @param {string} url - optional url to use for the history state. Default uses current href 
		 * @returns {undefined}
		 */
		pushState: function ($container, objName, url) {
			var historyState = (history.state || {});
			historyState[objName] = {};
			$container.find('input, select').each(function () {
				historyState[objName][$(this).attr('name')] = $(this).val();
			});
			history.pushState(historyState, document.title, (url ? url : location.href));
		},
		/**
		 * Set the current search parameters to the current history state 
		 * @param {jQuery} $container - a container object which contains the input elements to handle
		 * @param {string} objName - name to use for the form data history object
		 * @param {string} url - optional url to use for the history state. Default uses current href 
		 * @returns {undefined}
		 */
		replaceState: function ($container, objName, url) {
			var historyState = (history.state || {});
			historyState[objName] = {};
			$container.find('input, select').each(function () {
				historyState[objName][$(this).attr('name')] = $(this).val();
			});
			history.replaceState(historyState, document.title, (url ? url : location.href));
		},
		/**
		 * Restore values of the forms input elements and return a url parameter 
		 * string of the key=value pairs
		 * @param {type} $container - a container object which contains the input elements to handle
		 * @param {type} objName - name to use for the form data history object
		 * @returns {String} - encoded url parameter string i.e. 'key1=val1&key2=val2&...'
		 */
		restoreState: function ($container, objName) {
			var formData = '';
			$.each(history.state[objName], function (name, val) {
				$container.find('[name="' + name + '"]').val(val);
				formData += encodeURIComponent(name) + '=' + encodeURIComponent(val) + '&';
			});
			return formData;
		},
		/**
		 * Adds an entry to the current history object
		 * @param {string} objName
		 * @param {mixed} objData
		 * @param {string} url
		 * @returns {undefined}
		 */
		addObject: function (objName, objData, url) {
			var historyState = (history.state || {});
			historyState[objName] = objData;
			history.replaceState(historyState, document.title, (url ? url : location.href));
		},
		/**
		 * Returns the data for the specified history object entry
		 * @param {string} objName
		 * @returns {history.state|unresolved}
		 */
		getObject: function (objName) {
			if (history.state[objName]) {
				return history.state[objName];
			}
			return null;
		}
	}; // $.formHistoryStateHelper	

}(jQuery));